import { useState } from 'react'
import { trackEvent } from '@/lib/api'
import { ThumbsDownIcon, ThumbsUpIcon } from '@phosphor-icons/react'

export function Feedback({ helpId }: { helpId: string }) {
  const [submitted, setSubmitted] = useState<boolean | null>(null)

  function submit(helpful: boolean) {
    setSubmitted(helpful)
    trackEvent({ eventType: 'help_feedback_submitted', helpId, helpful })
  }

  return (
    <div className="feedback">
      <span className="feedback-question">Was this article helpful?</span>
      {submitted === null ? (
        <div className="feedback-actions">
          <button type="button" className="ghost" onClick={() => submit(true)}>
            <ThumbsUpIcon size={15} weight="duotone" /> Yes
          </button>
          <button type="button" className="ghost" onClick={() => submit(false)}>
            <ThumbsDownIcon size={15} weight="duotone" /> No
          </button>
        </div>
      ) : (
        <span className="feedback-thanks">
          {submitted
            ? 'Thanks — glad it helped.'
            : 'Thanks — we use this to improve the library.'}{' '}
          Still stuck? Email{' '}
          <a href="mailto:support@scrambl.com">support@scrambl.com</a>.
        </span>
      )}
    </div>
  )
}
